import { auth } from '@app/services/firebase'
export const logout = async (resetSelectedCareer: () => void) => {
	await auth.signOut()
	resetSelectedCareer()
}
